
//

import React, { Component } from 'react';
import { Input, Button } from 'antd';
import { connect } from 'react-redux';
import './style.css';

// Actions
import { reset_password, sent_verification } from './actions/reset.action';

class Reset extends Component {
    constructor(props) {
        super( props );

        this.state = {
            email: 'none',
            verification: 'none',
            password: 'none',
            c_password: 'none',
            sent_verification: '',
            button_text: 'Send Code'
        }

        this.handleSubmit = this.handleSubmit.bind( this );
        this.handleBack = this.handleBack.bind( this );
        this.handleSentVerification = this.handleSentVerification.bind( this );

    }

    handleSubmit( e ){
        e.preventDefault();

        let email_pattern = /(\w(=?@)\w+\.{1}[a-zA-Z]{2,})/i;
        let email = email_pattern.test( this.state.email );

        if( email !== '' && email === true ){

            if( this.state.sent_verification !== '' ){
                
                if( this.state.c_password === this.state.password && 
                    this.state.c_password !== 'none' && this.state.password !== 'none' ){

                    if( this.state.verification !== '' & this.state.verification === this.state.sent_verification ){
    
                        this.props.reset_password( this.state );
    
                    } else {
                        this.setState({ verification: '' });
                    }

                } else {
                    this.setState({ password: '', c_password: '' });
                }

            } else {

                // Sent Verification
                this.handleSentVerification()

            }

        } else {
           this.setState({ email: '' });
        }
        
    }

    handleSentVerification(){
        this.props.sent_verification( this.state.email );
    }

    handleBack(){
        this.props.history.goBack();
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.reset.STATUS.CODE === '200' &&
            nextProps.reset.STATUS.MESSAGE === 'confirm verification' ) {
            
            this.setState({
                sent_verification: nextProps.reset.OUTPUT.DATA,
                button_text: 'Reset Password'
            });

        }

        if( nextProps.reset.STATUS.CODE === '200' &&
            nextProps.reset.STATUS.MESSAGE === 'Successfully Updated' ) {
            
            this.props.history.goBack();

        }

    }

    render() {
        return (
            <div className="login-wrapper password_field animated fadeIn">

                <label>Please enter the email address you used to create your account. 
                An email will be sent to you containing your verification code. 
                Once received, Please Enter below box</label>

                <form onSubmit={ this.handleSubmit } autoComplete="off">

                    <Input className={ ( this.state.email === '') ? 'br_error input': 'input'} autoComplete="off" placeholder="Enter Your Email" 
                        onChange={ (e) => this.state.email = e.target.value }/>

                    {

                        ( this.state.sent_verification !== '' ) ? 
                            <span>
                                <Input className={ ( this.state.verification === '') ? 'br_error input': 'input'} autoComplete="off" placeholder="Verification Code"
                                    onChange={ (e) => this.state.verification = e.target.value } />
                                <Input className={ ( this.state.password === '') ? 'br_error input': 'input'} type="password" autoComplete="off" placeholder="Password"
                                    onChange={ (e) => this.state.password = e.target.value } />
                                <Input className={ ( this.state.c_password === '') ? 'br_error input': 'input'} type="password" autoComplete="off" placeholder="Confirm Password"
                                    onChange={ (e) => this.state.c_password = e.target.value } />
                            </span>
                        : ''

                    }

                    <Button type="primary" htmlType="submit" className="login-form-button">
                        { this.state.button_text }
                    </Button>
                    
                    <Button onClick={ this.handleBack } className="mrg_l_10 login-form-button">
                        Back
                    </Button>

                    

                </form>

                
            </div>
        );
    }
}

function mapStateToProps( state ) {
    return {
        reset: state.reset_password
    }
}

export default connect( mapStateToProps, { reset_password, sent_verification })( Reset );



// WEBPACK FOOTER //
// ./src/pages/reset/index.js